import styled from 'styled-components';
import { shade } from 'polished';

import { colors, radius } from '../../styles/tokens';

export const Container = styled.button`
  width: 100%;
  height: 48px;

  display: flex;

  justify-content: space-between;
  align-items: center;

  padding: 0 20px;

  border: none;

  background-color: ${colors.surfaceContainer};

  border-radius: ${radius.md};

  transition: background-color 0.2s;

  &:hover {
    background-color: ${shade(0.1, colors.surfaceContainer)};
  }

  span {
    font-size: 14px;
    font-weight: 600;
    color: ${colors.onSurface};
  }
`;

export const IconWrapper = styled.div`
  display: flex;
`;
